module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-calendar-dfbefce1364b0e578022163b1b801e32.svg";